module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.c4668ed2.ttf";